import React from "react";
import BlockUi from '@availity/block-ui';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {Circles} from "react-loader-spinner";
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import { DropDownList, MultiSelect } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import * as ApproverServices from "./approverService.js";
import approverData from "./approverData.json";
import { Dialog,Window } from "@progress/kendo-react-dialogs";
import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import "./approver.scss";
import "../commonStyle/tmsStyle.scss";
import qs from "qs";
import { process } from "@progress/kendo-data-query";
import { count } from "@progress/kendo-data-query/dist/npm/array.operators";
import { Link } from "react-router-dom";
import DetailDialog from "../NCRMAuthorization/DetailDialog.jsx";
import { withRouter } from "../NCRMSHome/withRouter";

import $, { event } from "jquery";
import {NumericFormat} from "react-number-format";


const dataState = {
  sort: [
    { field: "docType", dir: "asc" },
    { field: "docTypeDesc", dir: "asc" },
    { field: "freightOrder", dir: "asc" },
    { field: "rfqNumber", dir: "asc" },
    { field: "quoteNumber", dir: "asc" },
    { field: "createdOn", dir: "asc" },
    { field: "chargeAmt", dir: "asc" },
    { field: "hawb", dir: "asc" },
    { field: "pro", dir: "asc" },
    { field: "invoiceAmt", dir: "asc" },
    { field: "currencyCode", dir: "asc" },
    { field: "carrierId", dir: "asc" },
    { field: "carrierScac", dir: "asc" },
    { field: "sourceLocid", dir: "asc" },
    { field: "sourceLocdesc", dir: "asc" },
    { field: "destLocid", dir: "asc" },
    { field: "destLocdesc", dir: "asc" },
    { field: "segment", dir: "asc" },
    { field: "tendMgr", dir: "asc" },
    { field: "status", dir: "asc" },
    { field: "remarks", dir: "asc" },
  ],
  take: 50,
  skip: 0,
};

class Approver extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      segmentsData: [],
      documentData: [],
      selectDocType: [
        { docType: "ZSSB", text: "Intel Shipment Request" },
        { docType: "ZMSB", text: "Multi Bid Request" },
        { docType: "ZEXC", text: "Invoice Adjustment Request " },
      ],
      selectedFreightOrderNumberFrom: "",
      selectedFreightOrderNumberTo: "",
      selectedRFQNumberFrom: "",
      selectedRFQNumberTo: "",
      selectedSegment: [],
      docTypeValue: [],
      statusArray: ["60", "75"],
      awaitingApprovalChecked: true,
      approvedChecked: false,
      rejectedChecked: false,
      invApprovalChecked: true,
      invApprovedChecked: false,
      invRejectedChecked: false,
      visible: false,
      approveData: [],
      rejectData: [],
      sendBackDocument: [],
      commentsValue: "",
      bindapproveData: approverData,
      approvalDocumentArray: [],
      dataState: dataState,
      validUser: false,
      invoiceVisibleDialog: false,
      dialogRequestIDNum: null,
    };

    this.okClick = this.okClick.bind(this);
  }

  toggleDialog = () => {
    this.setState({
      invoiceVisibleDialog: !this.state.invoiceVisibleDialog,
    });
    if (this.state.dialogRequestIDNum !== null) {
      console.log("dialogRequestIDNum");
      console.log(this.state.dialogRequestIDNum);
    }
  };

  awaitingApprlChange = (event) => {
    console.log("checking");
    console.log(event.target.checked);
    if (event.target.checked) {
      // this.state.awaitingApprovalChecked = true;
      this.state.statusArray.push("60");
      this.setState({
        awaitingApprovalChecked: true,
      });
    } else {
      this.setState({
        awaitingApprovalChecked: false,
      });

      const index = this.state.statusArray.indexOf("60");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };

  ApprovedChange = (event) => {
    console.log(event.target.checked);
    if (event.target.checked) {
      this.state.statusArray.push("70");
      this.setState({
        approvedChecked: true,
      });
    } else {
      this.setState({
        approvedChecked: false,
      });

      const index = this.state.statusArray.indexOf("70");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };
  RejectedChange = (event) => {
    if (event.target.checked) {
      this.state.statusArray.push("80");
      this.setState({
        rejectedChecked: true,
      });
    } else {
      this.setState({
        rejectedChecked: false,
      });

      const index = this.state.statusArray.indexOf("80");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };

  invoiceApprlChange = (event) => {
    if (event.target.checked) {
      this.state.statusArray.push("75");
      this.setState({
        invApprovalChecked: true,
      });
    } else {
      this.setState({
        invApprovalChecked: false,
      });

      const index = this.state.statusArray.indexOf("75");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };

  invoiceApprovedChange = (event) => {
    if (event.target.checked) {
      this.state.statusArray.push("76");
      this.setState({
        invApprovedChecked: true,
      });
    } else {
      this.setState({
        invApprovedChecked: false,
      });

      const index = this.state.statusArray.indexOf("76");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };

  invoiceRejectedChange = (event) => {
    if (event.target.checked) {
      this.state.statusArray.push("78");
      this.setState({
        invRejectedChecked: true,
      });
    } else {
      this.setState({
        invRejectedChecked: false,
      });

      const index = this.state.statusArray.indexOf("78");
      if (index > -1) {
        this.state.statusArray.splice(index, 1);
      }
    }
  };

  async approveDocument(dataItem, e) {
    $("#myModal").show();
    this.state.approveData.push(dataItem.dataItem);
  }

  async rejectDocument(dataItem, e) {
    $("#myModal").show();
    this.state.rejectData.push(dataItem.dataItem);
  }

  async sendBackDocument(dataItem, e) {
    $("#myModal").show();
    this.state.sendBackDocument.push(dataItem.dataItem);
  }

  fromDateHandleChange = (event) => {
    this.setState({
      selectedFreightOrderFromDate: event.value,
    });
  };

  toDateHandleChange = (event) => {
    this.setState({
      selectedFreightOrderToDate: event.value,
    });
  };

  // fromDateHandleChange = (event) => {

  //     this.setState ({

  //         requestFrom : event.value
  //     })
  // }

  // toDateHandleChange = (event) => {

  //     this.setState ({

  //         requestTo : event.value
  //     })
  // }

  handleDocTypeChange = (event) => {
    this.setState({
      selectDocType: event.target.value,
    });
  };

  handleSegmentChange = (event) => {
    this.setState({
      selectedSegment: event.target.value,
    });
  };

  textAreaChange = (event) => {
    this.setState({
      commentsValue: event.target.value,
    });
  };

  handleRequestIDFromChange = (event) => {
    this.setState({
      selectedFreightOrderNumberFrom: event.target.value,
    });
  };

  handleRequestIDToChange = (event) => {
    this.setState({
      selectedFreightOrderNumberTo: event.target.value,
    });
  };

  rfqNumberFromChange = (event) => {
    this.setState({
      selectedRFQNumberFrom: event.target.value,
    });
  };

  rfqNumberToChange = (event) => {
    this.setState({
      selectedRFQNumberTo: event.target.value,
    });
  };

  async getSegmentData() {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;

    inputObj["Activity"] = "F4_WF_SEGMENTS";
    inputObj["Input"] = "";
    props.input = inputObj;

    const response = await GatewayGet(props, props.input);
    console.log(response);

    // const response = await ApproverServices.getSegments();
    this.setState({ segmentsData: response });
  }

  closeDialog() {
    //this.setState ({visible : false})
    $("#myModal").hide();
  }

  async updateComments(input) {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "Q_UPDATE_TENDRESP_NOTES";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
  }

  searchFOData() {
    this.getWorkListData();
  }

  resetData() {
    this.setState({
      selectDocType: [],
      selectedSegment: [],
      selectedFreightOrderNumberFrom: "",
      selectedFreightOrderNumberTo: "",
      selectedRFQNumberFrom: "",
      selectedRFQNumberTo: "",
    });
  }

  async postApprovalData(input) {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    InputJSONString = JSON.stringify(input);
    inputObj["Activity"] = "FO_FINANCE_APPROVE";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const result = await GatewayGet(props, props.input);
    console.log("result", result);
    return result;
  }

  async okClick() {
    $("#myModal").hide();

    this.setState({ blocking: true });
    if (this.state.approveData.length > 0) {
      var inputObj = {};
      inputObj["foNum"] = this.state.approveData[0].freightOrder;
      inputObj["rfqNum"] = this.state.approveData[0].rfqNumber;
      inputObj["respSeqNum"] = this.state.approveData[0].quoteNumber;
      inputObj["remarks"] = this.state.commentsValue;
      inputObj["status"] = "A";
      if (
        this.state.approveData[0].status == "60" ||
        this.state.approveData[0].status == "01"
      ) {
        var approvalResponse = await ApproverServices.FOFinanceApprove(
          inputObj
        );
        if (approvalResponse != undefined && approvalResponse != null) {
          var count = approvalResponse.length;
          var responseType = approvalResponse[count - 1].type;
          var responseMessage = approvalResponse[count - 1].message;

          if (responseType != undefined && responseType != null) {
            if (responseType == "S")
              // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"success");
              toast.success(
                this.state.approveData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
            // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"error");
            else
              toast.error(
                this.state.approveData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
          } else {
            // angular.element("#notification").getKendoNotification().show("Invalid Response Type","error");
            toast.error("Invalid Response Type", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            });
          }
        } else {
          // angular.element("#notification").getKendoNotification().show("Invalid Response","error");
          toast.error("Invalid Response", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }

        // var dataSource = angular.element("#aw-kendogridInner").data("kendoGrid").dataSource;
        var commentsHiddenIdVal = this.state.commentsValue;

        if (this.state.approveData[0].docType == "ZSSB")
          this.state.approveData[0].status = "70";
        else if (this.state.approveData[0].docType == "ZMSB")
          this.state.approveData[0].status = "02";
        else if (this.state.approveData[0].docType == "ZEXC")
          this.state.approveData[0].status = "90";

        this.state.approveData[0].remarks = commentsHiddenIdVal;

        for (var i = 0; i < this.state.approvalDocumentArray.length; i++) {
          if (
            this.state.approvalDocumentArray[i].docType ==
              this.state.approveData[0].docType &&
            this.state.approvalDocumentArray[i].freightOrder ==
              this.state.approveData[0].freightOrder &&
            this.state.approvalDocumentArray[i].rfqNumber ==
              this.state.approveData[0].rfqNumber
          ) {
            if (this.state.approveData[0].docType == "ZSSB")
              this.state.approvalDocumentArray[i].status = "70";
            else if (this.state.approveData[0].docType == "ZMSB")
              this.state.approvalDocumentArray[i].status = "02";
            else if (this.state.approveData[0].docType == "ZEXC")
              this.state.approvalDocumentArray[i].status = "90";

            this.state.approveData[0].remarks = commentsHiddenIdVal;

            this.state.approvalDocumentArray[i].remarks =
              this.state.approveData[0].remarks;

            // var gridDataSource = new kendo.data.DataSource({
            //     data: vm.approvalDocumentArray,
            //     pageSize: 10
            // });

            // var gridData = angular.element("#aw-kendogridInner").data("kendoGrid");
            // gridData.setDataSource(gridDataSource);

            // blockUI.stop();
            this.setState({
              approvalDocumentArray: this.state.approvalDocumentArray,
            });

            this.setState({ blocking: false });

            var commentsObj = {};
            commentsObj["RFQ_NUMBER"] = this.state.approveData[0].rfqNumber;
            commentsObj["RESP_NUMBER"] = this.state.approveData[0].quoteNumber;
            commentsObj["COMMENTS"] = this.state.commentsValue;

            this.updateComments(commentsObj);
          }
        }
      }
      // this.postApprovalData(inputObj);
      else {
        var invApprovalResponse = await ApproverServices.FOInvoiceApprove(
          inputObj
        );
        console.log("invApprovalResponse", invApprovalResponse);
        var responseArray = invApprovalResponse;

        if (responseArray != undefined && responseArray != null) {
          var count = responseArray.length;
          var responseType = responseArray[count - 1].type;
          var responseMessage = responseArray[count - 1].message;

          if (responseType != undefined && responseType != null) {
            if (responseType == "S")
              //  angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"success");
              toast.success(
                this.state.approveData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
            //  angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"error");
            else
              toast.error(
                this.state.approveData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
          } else {
            //  angular.element("#notification").getKendoNotification().show("Invalid Response Type","error");
            toast.error("Invalid Response Type", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            });
          }
        } else {
          //  angular.element("#notification").getKendoNotification().show("Invalid Response","error");
          toast.error("Invalid Response", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }

        //  var dataSource = angular.element("#aw-kendogridInner").data("kendoGrid").dataSource;
        var commentsHiddenIdVal = this.state.commentsValue;

        if (this.state.approveData[0].docType == "ZSSB")
          this.state.approveData[0].status = "76";
        else if (this.state.approveData[0].docType == "ZMSB")
          this.state.approveData[0].status = "02";
        else if (this.state.approveData[0].docType == "ZEXC")
          this.state.approveData[0].status = "90";

        this.state.approveData[0].remarks = commentsHiddenIdVal;

        for (var i = 0; i < this.state.approvalDocumentArray.length; i++) {
          if (
            this.state.approvalDocumentArray[i].docType ==
              this.state.approveData[0].docType &&
            this.state.approvalDocumentArray[i].freightOrder ==
              this.state.approveData[0].freightOrder &&
            this.state.approvalDocumentArray[i].rfqNumber ==
              this.state.approveData[0].rfqNumber
          ) {
            if (this.state.approveData[0].docType == "ZSSB")
              this.state.approvalDocumentArray[i].status = "76";
            else if (this.state.approveData[0].docType == "ZMSB")
              this.state.approvalDocumentArray[i].status = "02";
            else if (this.state.approveData[0].docType == "ZEXC")
              this.state.approvalDocumentArray[i].status = "90";

            this.state.approveData[0].remarks = commentsHiddenIdVal;

            this.state.approvalDocumentArray[i].remarks =
              this.state.approveData[0].remarks;
          }
        }

        // Refresh Grid
        //  var gridDataSource = new kendo.data.DataSource({
        //      data: vm.approvalDocumentArray,
        //      pageSize: 10
        //  });

        //  var gridData = angular.element("#aw-kendogridInner").data("kendoGrid");
        //  gridData.setDataSource(gridDataSource);
        this.setState({
          approvalDocumentArray: this.state.approvalDocumentArray,
        });
        this.setState({ blocking: false });
      }

      this.setState({ approveData: [] });
    } else if (this.state.sendBackDocument.length > 0) {
      //Send Back logic
      var inputObj = {};
      inputObj["foNum"] = this.state.sendBackDocument[0].freightOrder;
      inputObj["rfqNum"] = this.state.sendBackDocument[0].rfqNumber;
      inputObj["respSeqNum"] = this.state.sendBackDocument[0].quoteNumber;
      inputObj["remarks"] = this.state.commentsValue;
      inputObj["status"] = "S";
      var sendBackResponse = await ApproverServices.FOInvoiceApprove(inputObj);
      var responseArray = sendBackResponse;

      if (responseArray != undefined && responseArray != null) {
        var count = responseArray.length;
        var responseType = responseArray[count - 1].type;
        var responseMessage = responseArray[count - 1].message;

        if (responseType != undefined && responseType != null) {
          if (responseType == "S")
            // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"success");
            toast.success(
              this.state.sendBackDocument[0].freightOrder +
                " " +
                responseMessage,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
         progress: undefined,
        theme:"colored"              }
            );
          // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"error");
          else
            toast.error(
              this.state.sendBackDocument[0].freightOrder +
                " " +
                responseMessage,
              {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
         progress: undefined,
        theme:"colored"              }
            );
        } else {
          // angular.element("#notification").getKendoNotification().show("Invalid Response Type","error");
          toast.error("Invalid Response Type", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }
      } else {
        // angular.element("#notification").getKendoNotification().show("Invalid Response","error");
        toast.error("Invalid Response", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
      }

      // var dataSource = angular.element("#aw-kendogridInner").data("kendoGrid").dataSource;
      var commentsHiddenIdVal = this.state.commentsValue;

      if (this.state.sendBackDocument[0].docType == "ZSSB")
        this.state.sendBackDocument[0].status = "77";
      else if (this.state.sendBackDocument[0].docType == "ZMSB")
        this.state.sendBackDocument[0].status = "77";
      else if (this.state.sendBackDocument[0].docType == "ZEXC")
        this.state.sendBackDocument[0].status = "77";

      this.state.sendBackDocument[0].remarks = commentsHiddenIdVal;

      for (var i = 0; i < this.state.approvalDocumentArray.length; i++) {
        if (
          this.state.approvalDocumentArray[i].docType ==
            this.state.sendBackDocument[0].docType &&
          this.state.approvalDocumentArray[i].freightOrder ==
            this.state.sendBackDocument[0].freightOrder &&
          this.state.approvalDocumentArray[i].rfqNumber ==
            this.state.sendBackDocument[0].rfqNumber
        ) {
          if (this.state.sendBackDocument[0].docType == "ZSSB")
            this.state.approvalDocumentArray[i].status = "77";
          else if (this.state.sendBackDocument[0].docType == "ZMSB")
            this.state.approvalDocumentArray[i].status = "77";
          else if (this.state.sendBackDocument[0].docType == "ZEXC")
            this.state.approvalDocumentArray[i].status = "77";

          this.state.sendBackDocument[0].remarks = commentsHiddenIdVal;

          this.state.approvalDocumentArray[i].remarks =
            this.state.sendBackDocument[0].remarks;
        }
      }

      // Refresh Grid
      // var gridDataSource = new kendo.data.DataSource({
      //     data: vm.approvalDocumentArray,
      //     pageSize: 10
      // });

      // var gridData = angular.element("#aw-kendogridInner").data("kendoGrid");
      // gridData.setDataSource(gridDataSource);

      // blockUI.stop();
      this.setState({
        approvalDocumentArray: this.state.approvalDocumentArray,
      });
      this.setState({ blocking: false, sendBackDocument: [] });
    } else {
      var inputObj = {};
      inputObj["foNum"] = this.state.rejectData[0].freightOrder;
      inputObj["rfqNum"] = this.state.rejectData[0].rfqNumber;
      inputObj["respSeqNum"] = this.state.rejectData[0].quoteNumber;
      inputObj["remarks"] = this.state.commentsValue;
      inputObj["status"] = "R";
      if (
        this.state.rejectData[0].status == "60" ||
        this.state.rejectData[0].status == "01"
      ) {
        var rejectResponse = await ApproverServices.FOFinanceReject(inputObj);
        var responseArray = rejectResponse;

        if (responseArray != undefined && responseArray != null) {
          var count = responseArray.length;
          var responseType = responseArray[count - 1].type;
          var responseMessage = responseArray[count - 1].message;

          if (responseType != undefined && responseType != null) {
            if (responseType == "S")
              // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"success");
              toast.success(
                this.state.rejectData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
            // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"error");
            else
              toast.error(
                this.state.rejectData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
          } else {
            // angular.element("#notification").getKendoNotification().show("Invalid Response Type","error");
            toast.error("Invalid Response Type", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            });
          }
        } else {
          // angular.element("#notification").getKendoNotification().show("Invalid Response","error");
          toast.error("Invalid Response", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }

        //var dataSource = angular.element("#aw-kendogridInner").data("kendoGrid").dataSource;
        var commentsHiddenIdVal = this.state.commentsValue;
        if (this.state.rejectData[0].docType == "ZSSB")
          this.state.rejectData[0].status = "80";
        else if (this.state.rejectData[0].docType == "ZMSB")
          this.state.rejectData[0].status = "03";
        else if (this.state.rejectData[0].docType == "ZEXC")
          this.state.rejectData[0].status = "80";

        this.state.rejectData[0].remarks = commentsHiddenIdVal;

        for (var i = 0; i < this.state.approvalDocumentArray.length; i++) {
          if (
            this.state.approvalDocumentArray[i].docType ==
              this.state.rejectData[0].docType &&
            this.state.approvalDocumentArray[i].freightOrder ==
              this.state.rejectData[0].freightOrder &&
            this.state.approvalDocumentArray[i].rfqNumber ==
              this.state.rejectData[0].rfqNumber
          ) {
            if (this.state.rejectData[0].docType == "ZSSB")
              this.state.approvalDocumentArray[i].status = "80";
            else if (this.state.rejectData[0].docType == "ZMSB")
              this.state.approvalDocumentArray[i].status = "03";
            else if (this.state.rejectData[0].docType == "ZEXC")
              this.state.approvalDocumentArray[i].status = "80";

            this.state.rejectData[0].remarks = commentsHiddenIdVal;

            this.state.approvalDocumentArray[i].remarks =
              this.state.rejectData[0].remarks;
          }
        }

        // Grid Refresh
        // var gridDataSource = new kendo.data.DataSource({
        // 	data: vm.approvalDocumentArray,
        // 	pageSize: 10
        // });

        // var gridData = angular.element("#aw-kendogridInner").data("kendoGrid");
        // gridData.setDataSource(gridDataSource);
        this.setState({
          approvalDocumentArray: this.state.approvalDocumentArray,
        });
        this.setState({ blocking: false });

        var commentsObj = {};
        commentsObj["RFQ_NUMBER"] = this.state.rejectData[0].rfqNumber;
        commentsObj["RESP_NUMBER"] = this.state.rejectData[0].quoteNumber;
        commentsObj["COMMENTS"] = this.state.commentsValue;

        this.updateComments(commentsObj);
      } else {
        var invRejectResponse = await ApproverServices.FOInvoiceReject(
          inputObj
        );
        var responseArray = invRejectResponse;

        if (responseArray != undefined && responseArray != null) {
          var count = responseArray.length;
          var responseType = responseArray[count - 1].type;
          var responseMessage = responseArray[count - 1].message;

          if (responseType != undefined && responseType != null) {
            if (responseType == "S")
              // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"success");
              toast.success(
                this.state.rejectData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
            // angular.element("#notification").getKendoNotification().show(dataItem.freightOrder + " " + responseMessage,"error");
            else
              toast.error(
                this.state.rejectData[0].freightOrder + " " + responseMessage,
                {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
           progress: undefined,
        theme:"colored"                }
              );
          } else {
            // angular.element("#notification").getKendoNotification().show("Invalid Response Type","error");
            toast.error("Invalid Response Type", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            });
          }
        } else {
          // angular.element("#notification").getKendoNotification().show("Invalid Response","error");
          toast.error("Invalid Response", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
        }

        // var dataSource = angular.element("#aw-kendogridInner").data("kendoGrid").dataSource;
        var commentsHiddenIdVal = this.state.commentsValue;
        if (this.state.rejectData[0].docType == "ZSSB")
          this.state.rejectData[0].status = "78";
        else if (this.state.rejectData[0].docType == "ZMSB")
          this.state.rejectData[0].status = "03";
        else if (this.state.rejectData[0].docType == "ZEXC")
          this.state.rejectData[0].status = "80";

        this.state.rejectData[0].remarks = commentsHiddenIdVal;

        for (var i = 0; i < this.state.approvalDocumentArray.length; i++) {
          if (
            this.state.approvalDocumentArray[i].docType ==
              this.state.rejectData[0].docType &&
            this.state.approvalDocumentArray[i].freightOrder ==
              this.state.rejectData[0].freightOrder &&
            this.state.approvalDocumentArray[i].rfqNumber ==
              this.state.rejectData[0].rfqNumber
          ) {
            if (this.state.rejectData[0].docType == "ZSSB")
              this.state.approvalDocumentArray[i].status = "78";
            else if (this.state.rejectData[0].docType == "ZMSB")
              this.state.approvalDocumentArray[i].status = "03";
            else if (this.state.rejectData[0].docType == "ZEXC")
              this.state.approvalDocumentArray[i].status = "80";

            this.state.rejectData[0].remarks = commentsHiddenIdVal;

            this.state.approvalDocumentArray[i].remarks =
              this.state.rejectData[0].remarks;
          }
        }

        // // Grid Refresh
        // var gridDataSource = new kendo.data.DataSource({
        // 	data: vm.approvalDocumentArray,
        // 	pageSize: 10
        // });

        // var gridData = angular.element("#aw-kendogridInner").data("kendoGrid");
        // gridData.setDataSource(gridDataSource);
        this.setState({
          approvalDocumentArray: this.state.approvalDocumentArray,
        });
        this.setState({ blocking: false, rejectData: [] });
      }
      this.setState({ rejectData: [] });
    }

    this.setState({ commentsValue: "" });
  }

  getDocTypeData() {
    var docTypeArray = [];
    var docTypeObj = {};
    docTypeObj["docType"] = "ZSSB";
    docTypeObj["text"] = "Intel Shipment Request";
    docTypeArray.push(docTypeObj);
    docTypeObj = {};
    docTypeObj["docType"] = "ZMSB";
    docTypeObj["text"] = "Multi-Bid Request";
    docTypeArray.push(docTypeObj);
    docTypeObj = {};
    docTypeObj["docType"] = "ZEXC";
    docTypeObj["text"] = "Invoice Adjustment Request";
    docTypeArray.push(docTypeObj);
    this.setState({ documentData: docTypeArray });
  }

  async getWorkListData() {
    var docTypeArray = [];
    var selectedSegmentData = [];
    var gridData = [];

    this.state.documentOptions = {};
    this.state.showWorkflowGrid = false;

    // Mandatory Validation
    if (
      this.state.selectDocType == undefined ||
      this.state.selectDocType == null ||
      this.state.selectDocType == ""
    ) {
      // angular.element('.docTypeClass').addClass('mandatoryClass');
      toast.error("Doc Type is Mandatory", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ blocking: false });
      return;
    } else {
      // angular.element('.docTypeClass').removeClass('mandatoryClass');

      for (var i = 0; i < this.state.selectDocType.length; i++) {
        docTypeArray.push(this.state.selectDocType[i].docType);
      }
    }

    if (
      this.state.selectedFreightOrderFromDate == undefined ||
      this.state.selectedFreightOrderFromDate == null ||
      this.state.selectedFreightOrderFromDate == ""
    ) {
      // angular.element('.freightOrderFromDateClass').addClass('mandatoryClass');

      toast.error("Freight Order Created Date From is Mandatory", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ blocking: false });
      return;
    }

    if (
      this.state.statusArray != undefined ||
      this.state.statusArray != null ||
      this.state.statusArray != ""
    ) {
      if (this.state.statusArray.length == 0) {
        // angular.element('.checkboxClass').addClass('mandatoryClass');

        toast.error("Approval Status is Mandatory", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
   progress: undefined,
        theme:"colored"        });
        this.setState({ blocking: false });
        return;
      } else {
        // angular.element('.checkboxClass').removeClass('mandatoryClass');
      }
    } else {
      // angular.element('.checkboxClass').removeClass('mandatoryClass');
    }

    // FO Number To Validation
    if (
      this.state.selectedFreightOrderNumberTo != undefined &&
      this.state.selectedFreightOrderNumberTo != null &&
      this.state.selectedFreightOrderNumberTo != ""
    ) {
      if (
        this.state.selectedFreightOrderNumberFrom != undefined &&
        this.state.selectedFreightOrderNumberFrom != null &&
        this.state.selectedFreightOrderNumberFrom
      ) {
        if (
          parseInt(this.state.selectedFreightOrderNumberFrom, 10) >
          parseInt(this.state.selectedFreightOrderNumberTo, 10)
        ) {
          // angular.element('.foNumberFromClass').addClass('mandatoryClass');

          toast.error("Freight Order From is greater than Freight Order To", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          this.setState({ blocking: false });
          return;
        }
      } else {
        // angular.element('.foNumberFromClass').addClass('mandatoryClass');

        toast.error(
          "Freight Order From is mandatory when Freight Order To is selected",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );
        this.setState({ blocking: false });
        return;
      }
    }
    // angular.element('.foNumberFromClass').removeClass('mandatoryClass');

    // RFQ Number To Validation
    if (
      this.state.selectedRFQNumberTo != undefined &&
      this.state.selectedRFQNumberTo != null &&
      this.state.selectedRFQNumberTo != ""
    ) {
      if (
        this.state.selectedRFQNumberFrom != undefined &&
        this.state.selectedRFQNumberFrom != null &&
        this.state.selectedRFQNumberFrom != ""
      ) {
        if (
          parseInt(this.state.selectedRFQNumberFrom, 10) >
          parseInt(this.state.selectedRFQNumberTo, 10)
        ) {
          // angular.element('.rfqFromClass').addClass('mandatoryClass');

          toast.error("RFQ For ZMSB From is greater than RFQ For ZMSB To", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          });
          this.setState({ blocking: false });
          return;
        }
      } else {
        // angular.element('.rfqFromClass').addClass('mandatoryClass');

        toast.error(
          "RFQ For ZMSB From is mandatory when RFQ For ZMSB To is selected",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );
        this.setState({ blocking: false });
        return;
      }
    }
    // angular.element('.rfqFromClass').removeClass('mandatoryClass');

    var formattedFreightOrderFromDate = "";
    if (
      this.state.selectedFreightOrderFromDate != null &&
      this.state.selectedFreightOrderFromDate != undefined &&
      this.state.selectedFreightOrderFromDate != ""
    ) {
      var d = new Date(this.state.selectedFreightOrderFromDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderFromDate = [year, month, day].join("");
    }

    var formattedFreightOrderToDate = "";
    if (
      this.state.selectedFreightOrderToDate != null &&
      this.state.selectedFreightOrderToDate != undefined &&
      this.state.selectedFreightOrderToDate != ""
    ) {
      var d = new Date(this.state.selectedFreightOrderToDate),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      formattedFreightOrderToDate = [year, month, day].join("");
    }

    if (
      formattedFreightOrderToDate != undefined &&
      formattedFreightOrderToDate != null &&
      formattedFreightOrderToDate != ""
    ) {
      if (
        formattedFreightOrderFromDate != undefined &&
        formattedFreightOrderFromDate != null &&
        formattedFreightOrderFromDate != ""
      ) {
        if (
          parseInt(formattedFreightOrderFromDate, 10) >
          parseInt(formattedFreightOrderToDate, 10)
        ) {
          // angular.element('.freightOrderFromDateClass').addClass('mandatoryClass');

          toast.error(
            "FO Created From Date is greater than FO Created To Date",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
       progress: undefined,
        theme:"colored"            }
          );
          this.setState({ blocking: false });
          return;
        }
      }
    }
    // angular.element('.freightOrderFromDateClass').removeClass('mandatoryClass');

    if (this.state.selectedSegment.length > 0) {
      for (var j = 0; j < this.state.selectedSegment.length; j++) {
        selectedSegmentData.push(this.state.selectedSegment[j].text);
      }
    }

    var input = {};
    input["tor_type"] = docTypeArray;
    input["fo_number_from"] = this.state.selectedFreightOrderNumberFrom;
    input["fo_number_to"] = this.state.selectedFreightOrderNumberTo;
    input["createddate_start"] = formattedFreightOrderFromDate;
    input["createddate_end"] = formattedFreightOrderToDate;
    input["rfq_number_from"] = this.state.selectedRFQNumberFrom;
    input["rfq_number_to"] = this.state.selectedRFQNumberTo;

    input["segment_id"] = selectedSegmentData;

    input["submitted_by"] = "";
    input["appr_by"] = "";
    input["appr_status"] = this.state.statusArray;
    const tor_key = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).torID;
    if (typeof tor_key !== "undefined" && tor_key) {
      input["tor_key"] = tor_key;
    }

    // Make POST call
    let props = {};
    let inputObj = {};
    let InputJSONString = JSON.stringify(input);
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;

    inputObj["Activity"] = "APPR_WLIST";
    inputObj["Input"] = InputJSONString;
    props.input = inputObj;

    const worklistData = await GatewayGet(props, props.input);
    console.log(worklistData);

    // const response = await ApproverServices.getSegments();

    //   const worklistData = await ApproverServices.getApproverWorklist(inputObj);

    console.log(worklistData);
    if (worklistData.status == "FAILURE") {
      toast.error(worklistData.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
 progress: undefined,
        theme:"colored"      });
      this.setState({ blocking: false });
      this.setState({ approvalDocumentArray: [] });
    } else {
      gridData = worklistData.outputData;
      for (var i = 0; i < gridData.length; i++) {
        gridData[i].freightOrder = gridData[i].freightOrder.replace(/^0+/, "");
        gridData[i].rfqNumber = gridData[i].rfqNumber.replace(/^0+/, "");
      }

      this.setState({ approvalDocumentArray: gridData });
    }
  }

  async getUserDetails() {
    let props = {};
    let inputObj = {};
    let InputJSONString = "";
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;

    inputObj["Activity"] = "GET_USER_DETAILS";
    inputObj["Input"] = "";
    props.input = inputObj;

    const userResponse = await GatewayGet(props, props.input);

    if (userResponse.STATUS == "SUCCESS") {
      // userResponse.RESULT.USER_TYPE == "FINANCEAPPROVER"
      if (userResponse.RESULT.USER_TYPE == "FINANCEAPPROVER") {
        this.getSegmentData();
        this.getDocTypeData();

        var fromDate = new Date();

        fromDate.setDate(fromDate.getDate() - 180);

        this.state.selectedFreightOrderFromDate = fromDate;

        var toDate = new Date();
        toDate.setDate(toDate.getDate() + 1);

        this.setState({ validUser: true });

        this.state.selectedFreightOrderToDate = toDate;
        console.log(approverData);
        this.getWorkListData();

        console.log(userResponse);
      } else {
        this.setState({ validUser: false });
        toast.error(
          "Invalid UserID!!! You are not authorized to view the page.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
     progress: undefined,
        theme:"colored"          }
        );
      }
    }

    // const response = await ApproverServices.getUserDetails();
  }

  componentDidMount() {
    // If the user redirects from email links
    // Parse the url and get tor_key and fo type and do api call
    const FOType = qs.parse(this.props.location.search, {
      ignoreQueryPrefix: true,
    }).FOType;

    if (typeof FOType !== "undefined") {
      if (FOType === "SingleBid") {
        this.setState({
          selectDocType: [{ docType: "ZSSB", text: "Intel Shipment Request" }],
        });
      } else if (FOType === "MultiBid") {
        this.setState({
          selectDocType: [{ docType: "ZMSB", text: "Multi Bid Request" }],
        });
      } else if (FOType === "InvAdj") {
        this.setState({
          selectDocType: [
            { docType: "ZEXC", text: "Invoice Adjustment Request " },
          ],
        });
      }
    }
    $("#myModal").hide();
    let profile = JSON.parse(sessionStorage.getItem("profile"));

    if (profile == null) {
      this.getUserDetails();
    } else {
      if (profile.USER_TYPE == "FINANCEAPPROVER") {
        this.getSegmentData();
        this.getDocTypeData();

        var fromDate = new Date();

        fromDate.setDate(fromDate.getDate() - 180);

        this.state.selectedFreightOrderFromDate = fromDate;

        var toDate = new Date();
        this.setState({ validUser: true });

        this.state.selectedFreightOrderToDate = toDate;
        console.log(approverData);
        this.getWorkListData();

        console.log(profile);
      }
    }
    // console.log(userData);
  }
  MyCustomCell = (props) => <CustomCell {...props} />;

  closeWindow() {
    $("#myModal").hide();
  }
  onButtonClick(e) {
   
    this.props.navigate('/intelshipment',{ state: {approvalData:e}})
 
  }
  render() {
    const grid = (
      <Grid
        //  data= {this.state.gridData}
        // data = {approverData}
        //   data={[...this.state.bindapproveData]}
        // data = {this.state.approvalDocumentArray}

        // width="100%"
        ScrollMode="scrollable"
        style={{ height: "600px", width: 'auto'}}
        pageable
        sortable
        filterable
        data={process(this.state.approvalDocumentArray, this.state.dataState)}
        {...this.state.dataState}
        onDataStateChange={(e) => {
          this.setState({ dataState: e.dataState });
        }}
        //     dataGrid="myGrid"
        //     dataBound={this.onDataBound}
        //     pageable={true}
        //     reorderable
        //     ref={(grid) => { this._grid = grid; }}
      >
        <GridColumn
          locked={true}
          field="docTypeDesc"
          title="Document Type"
          filter="text"
          width="150px"
        />
        <GridColumn
          locked={true}
          field="freightOrder"
          title="Request ID Number"
          filter="text"
          width="150px"
          cell={(props) => (
            <td
              className="k-grid-content-sticky"
              role="gridcell"
              aria-colindex="1"
              style={{ left: "150px", right: "0px",cursor:"pointer",color:"#6495ed" }} onClick={() => this.onButtonClick(props.dataItem)}
            >
              
                {props.dataItem.freightOrder}
             
            </td>
          )}
        />
        <GridColumn
          locked={true}
          title="Additional Details"
          width="150px"
          cell={(props) => (
            <td
              className="k-grid-content-sticky"
              role="gridcell"
              aria-colindex="1"
              style={{ left: "300px", right: "0px" }}
            >
              <button
                className="btn k-button k-button-icontext appbtn"
                onClick={() => {
                  this.setState({ dialogRequestIDNum: props.dataItem }, () => {
                    this.toggleDialog();
                  });
                }}
              >
                Details
              </button>
            </td>
          )}
        ></GridColumn>
        <GridColumn
          width="150px"
          title="Status"
          cell={(props) => (
            <td>
              {props.dataItem.status == "77" && (
                <span>
                  <span className="white-space:pre">
                    <div className="completedClass">
                      <i className="intelicon-priority-flag-solid completedIcon"></i>
                    </div>
                    <div className="completedLabel">
                      <label style={{ textAlign: "center" }}>Sent Back</label>
                    </div>
                  </span>
                </span>
              )}

              {(props.dataItem.status == "70" ||
                props.dataItem.status == "90" ||
                props.dataItem.status == "02" ||
                props.dataItem.status == "76") && (
                <span>
                  <span className="white-space:pre">
                    {/* <div className="completedClass">
<i className="intelicon-priority-flag-solid completedIcon" ></i>
</div> */}
                    <div className="approveClass">
                      <i className="intelicon-check approveIcon"></i>
                    </div>
                    {/* completedLabel */}
                    <div className="approveLabel">
                      <label style={{ textAlign: "center" }}>Approved</label>
                    </div>
                  </span>
                </span>
              )}

              {(props.dataItem.status == "80" ||
                props.dataItem.status == "03" ||
                props.dataItem.status == "78") && (
                <span>
                  <span className="white-space:pre">
                    <div className="RejectedClass">
                      <i className="intelicon-priority-flag-solid RejectedIcon"></i>
                    </div>
                    <div className="RejectLabel">
                      <label style={{ textAlign: "center" }}>Rejected</label>
                    </div>
                  </span>
                </span>
              )}
              {(props.dataItem.status == "60" ||
                props.dataItem.status == "01" ||
                props.dataItem.status == "75") && (
                <span>
                  <div className="pendingClass">
                    <i className="intelicon-information-max pendingIcon"></i>
                  </div>
                  <div className="pendingLabel">
                    <label style={{ textAlign: "center" }}>Pending</label>
                  </div>
                </span>
              )}
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="carrierScac"
          title="SCAC"
          filter="text"
          width="100px"
        ></GridColumn>
        <GridColumn
          field="hawb"
          title="HAWB Number"
          filter="text"
          width="150px"
        ></GridColumn>
        <GridColumn
          field="sourceLocdesc"
          title="Source"
          filter="text"
          width="250px"
        ></GridColumn>
        <GridColumn
          field="destLocdesc"
          title="Destination"
          filter="text"
          width="300px"
        ></GridColumn>
        <GridColumn
          field="chargeAmt"
          title="Non-Contracted Bid Amount"
          filter="text"
          width="200px"
          cell={(props) => (
            <td>
              <NumericFormat
                value={Number(props.dataItem.chargeAmt)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              />
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="invoiceAmt"
          title="Non-Contracted Invoice Amount"
          filter="text"
          width="200px"
          cell={(props) => (
            <td>
              <NumericFormat
                value={Number(props.dataItem.invoiceAmt)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              />
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="totalAmount"
          title="Total Amount"
          filter="text"
          width="150px"
          cell={(props) => (
            <td>
              <NumericFormat
                value={Number(props.dataItem.totalAmount)}
                displayType={"text"}
                thousandSeparator={true}
                decimalSeparator={
                  props.dataItem.currencyCode !== "JPY" ? "." : ""
                }
                decimalScale={props.dataItem.currencyCode !== "JPY" ? "2" : "0"}
                fixedDecimalScale={
                  props.dataItem.currencyCode !== "JPY" ? "true" : "false"
                }
              />
            </td>
          )}
        ></GridColumn>
        <GridColumn
          width="350px"
          title="Action"
          cell={(props) => (
            <td>
              {(props.dataItem.status == "60" ||
                props.dataItem.status == "1" ||
                props.dataItem.status == "75" ||
                props.dataItem.status == "04") && (
                <button
                  className="btn k-button k-button-icontext appbtn"
                  onClick={this.approveDocument.bind(this, props)}
                >
                  Approve
                </button>
              )}
              {(props.dataItem.status == "60" ||
                props.dataItem.status == "1" ||
                props.dataItem.status == "75" ||
                props.dataItem.status == "04") && (
                <button
                  className="btn k-button k-button-icontext  rejectbtn"
                  onClick={this.rejectDocument.bind(this, props)}
                >
                  Reject
                </button>
              )}
              {(props.dataItem.status == "01" ||
                props.dataItem.status == "75" ||
                props.dataItem.status == "04") && (
                <button
                  className="btn k-button k-button-icontext reset"
                  onClick={this.sendBackDocument.bind(this, props)}
                >
                  Send Back
                </button>
              )}
              {(props.dataItem.status == "70" ||
                props.dataItem.status == "77" ||
                props.dataItem.status == "80" ||
                props.dataItem.status == "90" ||
                props.dataItem.status == "02" ||
                props.dataItem.status == "03" ||
                props.dataItem.status == "76" ||
                props.dataItem.status == "78") && (
                <span>
                  <span className="white-space:pre">
                    <div className="completedClass">
                      <i className="intelicon-priority-flag-solid completedIcon"></i>
                    </div>
                    <div className="completedLabel">
                      <label style={{ textAlign: "center" }}>Completed</label>
                    </div>
                  </span>
                </span>
              )}
            </td>
          )}
        ></GridColumn>
        <GridColumn
          field="createdOn"
          title="Request Created Date"
          filter="text"
          width="200px"
        ></GridColumn>
        <GridColumn
          field="requestCreatedBy"
          title="Request Created By"
          filter="text"
          width="200px"
        ></GridColumn>
        <GridColumn
          field="pro"
          title="PRO Number"
          filter="text"
          width="150px"
        ></GridColumn>

        <GridColumn
          field="currencyCode"
          title="Currency"
          filter="text"
          width="80px"
        ></GridColumn>

        <GridColumn
          field="quoteNumber"
          title="Quotation Number"
          filter="text"
          width="200px"
        ></GridColumn>
        <GridColumn
          field="rfqNumber"
          title="Request For Quote"
          filter="text"
          width="200px"
        ></GridColumn>
      </Grid>
    );
    return (
      <div>
        {this.state.invoiceVisibleDialog &&
          this.state.dialogRequestIDNum !== null && (
            <Dialog title={"Additional Details"} onClose={this.toggleDialog}>
              <p
                style={{
                  margin: "25px",
                  textAlign: "center",
                }}
              >
                <DetailDialog
                  detailDialogData={
                    this.state.dialogRequestIDNum !== null
                      ? this.state.dialogRequestIDNum
                      : {}
                  }
                  gridData={this.state.approvalDocumentArray}
                ></DetailDialog>
              </p>
            </Dialog>
          )}
        <BlockUi
          tag="div"
          blocking={this.state.blocking}
          loader={
            <Circles
            color="#00BFFF"
            height="100"
            width="100"
            timeout="6000" //3 secs
          />
          }
        >
          <div></div>

          {this.state.validUser && (
            <MDBContainer fluid>
              <MDBRow>
                <MDBCol sm="12" className="titleBox">
                  <label style={{ textAlign: "center" }}>
                    Approval Worklist
                  </label>
                </MDBCol>
              </MDBRow>
              <br></br>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label>
                    Document Type <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol md="3">
                  <MultiSelect
                    data={this.state.documentData}
                    value={this.state.selectDocType}
                    dataItemKey="docType"
                    textField="text"
                    onChange={this.handleDocTypeChange}
                  ></MultiSelect>
                </MDBCol>
                <MDBCol md="1">
                  <label>Segment</label>
                </MDBCol>
                <MDBCol md="3">
                  <MultiSelect
                    data={this.state.segmentsData}
                    dataItemKey="value"
                    value={this.state.selectedSegment}
                    textField="text"
                    onChange={this.handleSegmentChange}
                  ></MultiSelect>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label>Request ID From</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.selectedFreightOrderNumberFrom}
                    onChange={this.handleRequestIDFromChange}
                    placeholder={"Request ID From"}
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label>To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.selectedFreightOrderNumberTo}
                    onChange={this.handleRequestIDToChange}
                    placeholder={"Request ID To"}
                  ></input>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label>
                    Request ID Created From <em>*</em>
                  </label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    value={this.state.selectedFreightOrderFromDate}
                    onChange={this.fromDateHandleChange}
                    format="MM/dd/yyyy"
                    formatPlaceholder="formatPattern"
                  ></DatePicker>
                </MDBCol>
                <MDBCol md="1">
                  <label>To</label>
                </MDBCol>
                <MDBCol md="3">
                  <DatePicker
                    value={this.state.selectedFreightOrderToDate}
                    onChange={this.toDateHandleChange}
                    format="MM/dd/yyyy"
                    formatPlaceholder="formatPattern"
                  ></DatePicker>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label>RFQ Number From</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.selectedRFQNumberFrom}
                    onChange={this.rfqNumberFromChange}
                    placeholder={"RFQ Number From"}
                  ></input>
                </MDBCol>
                <MDBCol md="1">
                  <label>To</label>
                </MDBCol>
                <MDBCol md="3">
                  <input
                    type="number"
                    className="form-control"
                    value={this.state.selectedRFQNumberTo}
                    onChange={this.rfqNumberToChange}
                    placeholder={"RFQ Number To"}
                  ></input>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBCol md="2">
                  <label>
                    Approval Status <em>*</em>
                  </label>
                </MDBCol>
                {/* <MDBCol ><input type = "checkbox" id = "awaitingApproval" checked = {this.state.awaitingApprovalChecked} onChange= {this.awaitingApprlChange}></input><label>Awaiting Approval</label></MDBCol>
                    <MDBCol ><input type = "checkbox" id = "approved" checked = {this.state.approvedChecked} onChange= {this.ApprovedChange}></input><label>Approved</label></MDBCol>
                    <MDBCol ><input type = "checkbox" id = "rejected" checked = {this.state.rejectedChecked} onChange= {this.RejectedChange}></input><label>Rejected</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "awaitingInvoiceApproval"  checked= {this.state.invApprovalChecked} onChange= {this.invoiceApprlChange}></input><label>Awaiting Invoice Approval</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "invoiceApproved" checked = {this.state.invApprovedChecked} onChange= {this.invoiceApprovedChange}></input><label>Invoice Approved</label></MDBCol>
                    <MDBCol><input type = "checkbox" id = "invoiceRejected" checked = {this.state.invRejectedChecked} onChange= {this.invoiceRejectedChange}></input><label>Invoice Rejected</label></MDBCol>
                </MDBRow> */}
                <MDBCol md="2">
                  <label>
                    <input
                      type="checkbox"
                      id="awaitingApproval"
                      checked={this.state.awaitingApprovalChecked}
                      onChange={this.awaitingApprlChange}
                    ></input>
                    &nbsp;Awaiting Approval
                  </label>
                </MDBCol>
                {/* <MDBCol md = "1"><label><input type = "checkbox" id = "approved" checked = {this.state.approvedChecked} onChange= {this.ApprovedChange}></input>&nbsp;Approved </label></MDBCol> */}
                {/* <MDBCol md = "1"><label><input type = "checkbox" id = "rejected" checked = {this.state.rejectedChecked} onChange= {this.RejectedChange}></input>&nbsp;Rejected</label></MDBCol> */}
                <MDBCol md="2">
                  <label>
                    <input
                      type="checkbox"
                      id="awaitingInvoiceApproval"
                      checked={this.state.invApprovalChecked}
                      onChange={this.invoiceApprlChange}
                    ></input>
                    &nbsp;Awaiting Invoice Approval
                  </label>
                </MDBCol>
                {/* <MDBCol md = "2"><label><input type = "checkbox" id = "invoiceApproved" checked = {this.state.invApprovedChecked} onChange= {this.invoiceApprovedChange}></input>&nbsp;Invoice Approved</label></MDBCol> */}
                {/* <MDBCol md = "2"><label><input type = "checkbox" id = "invoiceRejected" checked = {this.state.invRejectedChecked} onChange= {this.invoiceRejectedChange}></input>&nbsp;Invoice Rejected</label></MDBCol> */}
              </MDBRow>
              <br></br>
              {/* <MDBRow>
                    <MDBCol sm="1">

                        <button type="submit" className="btn k-button k-button-icontext" onClick = {this.searchFOData.bind(this)}>Search</button>
                        <button type="submit" className="btn btn-default reset" style= {{border : "1px solid"}} onClick ={this.resetData.bind(this)}>Reset</button>
                     
                    </MDBCol>
                    <MDBCol sm = "1">
                   
                    </MDBCol>
                </MDBRow> */}
              <MDBRow>
                <MDBCol>
                  <p className="btnalign">
                    <button
                      type="submit"
                      onClick={this.searchFOData.bind(this)}
                      className="btn k-button k-button-icontext mt"
                    >
                      Search
                    </button>
                    <button
                      type="submit"
                      className="btn k-button k-button-icontext reset"
                      onClick={this.resetData.bind(this)}
                    >
                      Reset
                    </button>
                  </p>
                </MDBCol>
              </MDBRow>
              <br></br>
              <MDBRow>
                <MDBContainer fluid>
                  <MDBRow>
                    <MDBCol>
                      <div className="appGrid">{grid}</div>
                    </MDBCol>
                  </MDBRow>
                </MDBContainer>
              </MDBRow>
            </MDBContainer>
          )}

          {!this.state.validUser && (
            <MDBContainer>
              <MDBRow>
                <MDBCol>
                  {!this.state.validUser && (
                    <div>
                      {!this.state.validUser && (
                        <label className="error">
                          Invalid UserID!!! You are not authorized to view the
                          page.
                        </label>
                      )}
                    </div>
                  )}
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          )}
          <div className="modals" id="myModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="headerTitle">Required Confirmation</h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeWindow}
                >
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <form className="k-form">
                  <fieldset>
                    <legend></legend>

                    <MDBContainer>
                      <MDBRow>
                        <MDBCol md="2">
                          <label>Comments </label>
                        </MDBCol>
                        <MDBCol>
                          <textarea
                            value={this.state.commentsValue}
                            onChange={this.textAreaChange.bind(this)}
                          ></textarea>
                        </MDBCol>
                      </MDBRow>
                    </MDBContainer>
                  </fieldset>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="k-button k-button-icontext"
                  onClick={this.okClick}
                >
                  ok
                </button>
                <button
                  type="button"
                  className="k-button k-button-icontext"
                  onClick={this.closeDialog}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </BlockUi>
      </div>
    );
  }
}

export default withRouter(Approver);

class CustomCell extends React.Component {
  render() {
    if (this.props.field == "Action") {
      const statusValue = this.props.dataItem.status;
      return (
        <tr>
          <td>
            {(statusValue == "60" ||
              statusValue == "1" ||
              statusValue == "75" ||
              statusValue == "04") && (
              <span>
                <button className="k-button k-button-icontext">Approve</button>
              </span>
            )}
            {(statusValue == "60" ||
              statusValue == "1" ||
              statusValue == "75" ||
              statusValue == "04") && (
              <span>
                <button className="k-button k-button-icontext rejectbtn">
                  Reject
                </button>
              </span>
            )}
            {(statusValue == "1" ||
              statusValue == "75" ||
              statusValue == "04") && (
              <span>
                <button className="k-button k-button-icontext reset">
                  SendBack
                </button>
              </span>
            )}
            {(statusValue == "70" ||
              statusValue == "77" ||
              statusValue == "80" ||
              statusValue == "90" ||
              statusValue == "02" ||
              statusValue == "03" ||
              statusValue == "76" ||
              statusValue == "78") && (
              <span>
                <span className="white-space:pre">
                  <div className="completedClass">
                    <i className="intelicon-priority-flag-solid completedIcon"></i>
                  </div>
                  <div className="completedLabel">
                    <label>Completed</label>
                  </div>
                </span>
              </span>
            )}
          </td>
        </tr>
      );
    }
  }
}
